export const FORM_MODE = {
  VIEW: "view",
  EDIT: "edit",
  CREATE: "create",
};
